import styled from "styled-components";
import { motion } from "framer-motion";


const Footer = () => {
  return (
    <Fotter>
      <div className="footer-container">
        <div className="trademark">
          <p>™ Trademark of Mazuma Bank, All Rights Reserved</p>
        </div>

        <div className="footer-links">
          <p>Accessibility</p>
          <p>SiteMap</p>
          <p>Privacy & Legal</p>
          <p>Security</p>
        </div>
      </div>
    </Fotter>
  );
};

export default Footer;

const Fotter = styled(motion.footer)`
  min-height: 5rem;
  background: #19456b;
  color: white;
  font-weight: 300;
  font-family: "Open Sans";
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1124px) {
    padding: 0rem;
  }

  .footer-container {
    margin: auto;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 0rem 3rem;
    @media (min-width: 1600px) {
      width: 100rem;
    }

    @media (max-width: 700px) {
      flex-wrap: wrap;
      padding: 0rem;
    }
  }

  .trademark {
    font-size: 0.6rem;
    flex: 1 1 50rem;

    @media (max-width: 700px) {
      text-align: center;
      padding: 1rem 0rem;
      font-size: 0.5rem;
    }
  }
  .footer-links {
    flex: 1 1 20rem;

    p {
      padding: 0rem 1rem;

      &:hover {
        color: #e4e4e4;
      }
    }

    cursor: pointer;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-end;
    font-size: 0.7rem;
    font-weight: 600;
    padding-right: 1rem;

    @media (max-width: 1024px) {
      padding-right: 0rem;
    }

    @media (max-width: 700px) {
      justify-content: space-around;
      padding-right: 0rem;
      text-align: center;
      font-size: 0.7rem;
      padding-bottom: 1rem;
    }

    @media (max-width: 400px) {
      font-size: 0.5rem;
    }

    @media (max-width: 305px) {
      font-size: 0.5rem;
      flex-wrap: wrap;
      p {
        padding: 0.5rem;
      }
    }
  }
`;
